import { useTranslation } from "react-i18next";
import {
  useGetViolationTypesForSelectLazyQuery,
  ViolationStatusType,
} from "~/schemas/generated/graphql";
import { useEffect } from "react";
import { debounce, get } from "lodash";
import translit from "translit-passport";

export const onScrollBottomViolationTypes = (onlyActive = false) => {
  const { t } = useTranslation();
  let isEn = localStorage.getItem("language") === "en";

  const [GetViolationTypesForSelectQuery, { data, loading, fetchMore }] =
    useGetViolationTypesForSelectLazyQuery({
      variables: {
        page: 0,
        count: 25,
        status: onlyActive ? ViolationStatusType.Active : undefined,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    GetViolationTypesForSelectQuery();
  }, []);

  const violationTypesForSelect = [
    {
      value: 0,
      label: t("violationRecording.selector"),
    },
    ...get(data, "ViolationTypesGetter.get.items", []).map(({ id, name }) => {
      return {
        value: id,
        label: isEn ? translit.cyrillicToLatin(name) : name,
      };
    }),
  ];

  const getAvgCorrectionTime = (selectedValue) => {
    return get(data, "ViolationTypesGetter.get.items", []).filter(
      (el) => el.id === selectedValue.value
    )[0]?.AvgCorrectionDays;
  };

  const introspectionHandler = () => {
    if (violationTypesForSelect.length < 25) {
      return;
    }
    const page = Math.ceil(violationTypesForSelect.length / 26);
    fetchMore({
      variables: {
        page,
      },
      updateQuery: ({ ViolationTypesGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { ViolationTypesGetter };
        }
        return {
          ViolationTypesGetter: {
            ...ViolationTypesGetter,
            get: {
              ...ViolationTypesGetter.get,
              items: [
                ...ViolationTypesGetter.get.items,
                ...get(fetchMoreResult, "ViolationTypesGetter.get.items", []),
              ],
            },
          },
        };
      },
    });
  };

  const searchType = debounce((searchText: string) => {
    GetViolationTypesForSelectQuery({
      variables: {
        page: 0,
        name: searchText,
        status: onlyActive ? ViolationStatusType.Active : undefined,
      },
    });
  });

  return {
    getAvgCorrectionTime,
    violationTypesForSelect,
    introspectionHandler,
    searchType,
    GetViolationTypesLoading: !!loading,
  };
};
